import React, { useEffect, useState } from "react";

export default function PhotosPexels({ word }) {
  const [photos, setPhotos] = useState([]);
  const apiKey = process.env.REACT_APP_API_KEY_PEXELS;
  const apiURL = process.env.REACT_APP_API_URL_PEXELS;

  useEffect(() => {
    if (!word || !apiKey || !apiURL) return;
    fetch(`${apiURL}${word}&per_page=2`, {
      headers: {
        Authorization: apiKey,
      },
    })
      .then((response) => response.json())
      .then((data) => setPhotos(data.photos || []))
      .catch((error) => {
        console.error("Error fetching photos:", error);
        setPhotos([]);
      });
  }, [word, apiKey, apiURL]);

  return (
    <div className="Photos">
      {photos.length > 0 ? (
        photos.map((photo) => (
          <img
            key={photo.id}
            src={photo.src.small}
            alt={photo.alt || "Pexels"}
            className="PhotoGallery"
          />
          
        ))
      ) : (
        <p>No photos found.</p>
      )}
    </div>
  );
}
